import React from "react";
import injectIntl from "../../../common/helpers/injectIntl";
import Modal from "../Modal";

import ComposerForm from "./lazy";
import { IProps } from "./interfaces";


export default injectIntl(
    (props: IProps) => (
        <Modal close={props.close}>
            <ComposerForm {...props} />
        </Modal>
    )
);
